// @flow

// const checkmarkCircle = require("../../../../assets/images/checkmark-circle.svg");

// const checkmarkCircleUnselected = require("../../../../assets/images/checkmark-circle-unselected.svg");

export const MANUAL_ATTACHMENT_SLIP = 'manualSlip';

export const depositTypeMap = {
  DIGITAL: { key: 'DIGITAL', displayValue: 'Digital' },
  MANUAL: { key: 'MANUAL', displayValue: 'Manual' }
};

export const depositSlipChequeData = {
  clientName:
    'MLL Express Services pvt ltd (Formerly known as Meru Travel Solutions Pvt Ltd)',
  cmsCode: 'Rivigo',
  selectTheMode: 'Cheque',
  depositSlipNumber: '2345678902',
  pickupDate: '25-05-2018',
  pickupLocation: 'Kirti Nagar',
  pickupPoint: 'Delhi',
  depositDate: '25-05-2018',
  possibleReasons: [
    'Already Deposited',
    'Amount misplaced',
    'Pending handover from BP/Captain'
  ],
  tableData: [
    {
      cn: '1244',
      instrument: 'Cash',
      bankname: 'HDFC',
      issuedBy: 'Deepak Fastner',
      collectedBy: 'Nikki Kumari',
      possibleReasons: null,
      amount: 1247,
      isSelected: true,
      reason: null
    },
    {
      cn: '1244',
      instrument: 'Cash',
      bankname: 'HDFC',
      issuedBy: 'Deepak Fastner',
      collectedBy: 'Nikki Kumari',
      possibleReasons: null,
      isSelected: true,
      reason: null,
      amount: 1247
    },
    {
      cn: '1244',
      instrument: 'Cash',
      bankname: 'HDFC',
      possibleReasons: null,
      issuedBy: 'Deepak Fastner',
      collectedBy: 'Nikki Kumari',
      amount: 1247,
      isSelected: true,
      reason: null
    },
    {
      cn: '1244',
      possibleReasons: null,
      instrument: 'Cash',
      bankname: 'HDFC',
      issuedBy: 'Deepak Fastner',
      collectedBy: 'Nikki Kumari',
      amount: '1247',
      isSelected: true,
      reason: null
    },
    {
      cn: '1244',
      possibleReasons: null,
      instrument: 'Cash',
      bankname: 'HDFC',
      issuedBy: 'Deepak Fastner',
      collectedBy: 'Nikki Kumari',
      amount: '1247',
      isSelected: true,
      reason: null
    },
    {
      cn: '1244',
      instrument: 'Cash',
      possibleReasons: null,
      bankname: 'HDFC',
      issuedBy: 'Deepak Fastner',
      collectedBy: 'Nikki Kumari',
      amount: '1247',
      isSelected: true,
      reason: null
    },
    {
      cn: '1244',
      instrument: 'Cash',
      bankname: 'HDFC',
      possibleReasons: null,
      issuedBy: 'Deepak Fastner',
      collectedBy: 'Nikki Kumari',
      amount: '1247',
      isSelected: true,
      reason: null
    },
    {
      isSelected: true,
      reason: null,
      cn: '1244',
      instrument: 'Cash',
      bankname: 'HDFC',
      issuedBy: 'Deepak Fastner',
      possibleReasons: null,
      collectedBy: 'Nikki Kumari',
      amount: '1247'
    },
    {
      cn: '1244',
      isSelected: true,
      reason: null,
      instrument: 'Cash',
      bankname: 'HDFC',
      issuedBy: 'Deepak Fastner',
      possibleReasons: null,
      collectedBy: 'Nikki Kumari',
      amount: '1247'
    },
    {
      cn: '1244',
      isSelected: true,
      reason: null,
      instrument: 'Cash',
      bankname: 'HDFC',
      issuedBy: 'Deepak Fastner',
      collectedBy: 'Nikki Kumari',
      possibleReasons: null,
      amount: '1248'
    },
    {
      cn: '1244',
      instrument: 'Cash',
      bankname: 'HDFC',
      issuedBy: 'Deepak Fastner',
      collectedBy: 'Nikki Kumari',
      possibleReasons: null,
      amount: 1247,
      isSelected: true,
      reason: null
    },
    {
      cn: '1244',
      instrument: 'Cash',
      bankname: 'HDFC',
      issuedBy: 'Deepak Fastner',
      collectedBy: 'Nikki Kumari',
      possibleReasons: null,
      isSelected: true,
      reason: null,
      amount: 1247
    },
    {
      cn: '1244',
      instrument: 'Cash',
      bankname: 'HDFC',
      possibleReasons: null,
      issuedBy: 'Deepak Fastner',
      collectedBy: 'Nikki Kumari',
      amount: 1247,
      isSelected: true,
      reason: null
    },
    {
      cn: '1244',
      possibleReasons: null,
      instrument: 'Cash',
      bankname: 'HDFC',
      issuedBy: 'Deepak Fastner',
      collectedBy: 'Nikki Kumari',
      amount: '1247',
      isSelected: true,
      reason: null
    },
    {
      cn: '1244',
      possibleReasons: null,
      instrument: 'Cash',
      bankname: 'HDFC',
      issuedBy: 'Deepak Fastner',
      collectedBy: 'Nikki Kumari',
      amount: '1247',
      isSelected: true,
      reason: null
    },
    {
      cn: '1244',
      instrument: 'Cash',
      possibleReasons: null,
      bankname: 'HDFC',
      issuedBy: 'Deepak Fastner',
      collectedBy: 'Nikki Kumari',
      amount: '1247',
      isSelected: true,
      reason: null
    },
    {
      cn: '1244',
      instrument: 'Cash',
      bankname: 'HDFC',
      possibleReasons: null,
      issuedBy: 'Deepak Fastner',
      collectedBy: 'Nikki Kumari',
      amount: '1247',
      isSelected: true,
      reason: null
    },
    {
      isSelected: true,
      reason: null,
      cn: '1244',
      instrument: 'Cash',
      bankname: 'HDFC',
      issuedBy: 'Deepak Fastner',
      possibleReasons: null,
      collectedBy: 'Nikki Kumari',
      amount: '1247'
    },
    {
      cn: '1244',
      isSelected: true,
      reason: null,
      instrument: 'Cash',
      bankname: 'HDFC',
      issuedBy: 'Deepak Fastner',
      possibleReasons: null,
      collectedBy: 'Nikki Kumari',
      amount: '1247'
    },
    {
      cn: '1244',
      isSelected: true,
      reason: null,
      instrument: 'Cash',
      bankname: 'HDFC',
      issuedBy: 'Deepak Fastner',
      collectedBy: 'Nikki Kumari',
      possibleReasons: null,
      amount: '1248'
    },
    {
      cn: '1244',
      instrument: 'Cash',
      bankname: 'HDFC',
      issuedBy: 'Deepak Fastner',
      collectedBy: 'Nikki Kumari',
      possibleReasons: null,
      amount: 1247,
      isSelected: true,
      reason: null
    },
    {
      cn: '1244',
      instrument: 'Cash',
      bankname: 'HDFC',
      issuedBy: 'Deepak Fastner',
      collectedBy: 'Nikki Kumari',
      possibleReasons: null,
      isSelected: true,
      reason: null,
      amount: 1247
    },
    {
      cn: '1244',
      instrument: 'Cash',
      bankname: 'HDFC',
      possibleReasons: null,
      issuedBy: 'Deepak Fastner',
      collectedBy: 'Nikki Kumari',
      amount: 1247,
      isSelected: true,
      reason: null
    },
    {
      cn: '1244',
      possibleReasons: null,
      instrument: 'Cash',
      bankname: 'HDFC',
      issuedBy: 'Deepak Fastner',
      collectedBy: 'Nikki Kumari',
      amount: '1247',
      isSelected: true,
      reason: null
    },
    {
      cn: '1244',
      possibleReasons: null,
      instrument: 'Cash',
      bankname: 'HDFC',
      issuedBy: 'Deepak Fastner',
      collectedBy: 'Nikki Kumari',
      amount: '1247',
      isSelected: true,
      reason: null
    },
    {
      cn: '1244',
      instrument: 'Cash',
      possibleReasons: null,
      bankname: 'HDFC',
      issuedBy: 'Deepak Fastner',
      collectedBy: 'Nikki Kumari',
      amount: '1247',
      isSelected: true,
      reason: null
    },
    {
      cn: '1244',
      instrument: 'Cash',
      bankname: 'HDFC',
      possibleReasons: null,
      issuedBy: 'Deepak Fastner',
      collectedBy: 'Nikki Kumari',
      amount: '1247',
      isSelected: true,
      reason: null
    },
    {
      isSelected: true,
      reason: null,
      cn: '1244',
      instrument: 'Cash',
      bankname: 'HDFC',
      issuedBy: 'Deepak Fastner',
      possibleReasons: null,
      collectedBy: 'Nikki Kumari',
      amount: '1247'
    },
    {
      cn: '1244',
      isSelected: true,
      reason: null,
      instrument: 'Cash',
      bankname: 'HDFC',
      issuedBy: 'Deepak Fastner',
      possibleReasons: null,
      collectedBy: 'Nikki Kumari',
      amount: '1247'
    },
    {
      cn: '1244',
      isSelected: true,
      reason: null,
      instrument: 'Cash',
      bankname: 'HDFC',
      issuedBy: 'Deepak Fastner',
      collectedBy: 'Nikki Kumari',
      possibleReasons: null,
      amount: '1248'
    }
  ]
};
// export const depositSlipCashData = {};
export const depositSlipCashData = {
  clientName:
    'MLL Express Services pvt ltd (Formerly known as Meru Travel Solutions Pvt Ltd)',
  cmsCode: 'Rivigo',
  selectTheMode: 'Cash',
  depositSlipNumber: '2345678902',
  pickupDate: '25-05-2018',
  pickupLocation: 'Kirti Nagar',
  pickupPoint: 'Delhi',
  depositDate: '25-05-2018',
  tableData: [
    {
      cn: '1244',
      instrument: 'Cash',
      collectedBy: 'Nikki Kumari',
      amount: 1,
      isSelected: true,
      reason: null,
      id: 1
    },
    {
      cn: '1245',
      instrument: 'Cash',
      collectedBy: 'Nikki Kumari',
      amount: 1247,
      isSelected: true,
      reason: null,
      id: 2
    },
    {
      cn: '1244',
      instrument: 'Cash',
      collectedBy: 'Nikki Kumari',
      amount: 1247,
      isSelected: true,
      reason: null,
      id: 3
    },
    {
      cn: '1245',
      instrument: 'Cash',
      collectedBy: 'Nikki Kumari',
      amount: 1247,
      isSelected: true,
      reason: null,
      id: 4
    },
    {
      cn: '1244',
      instrument: 'Cash',
      collectedBy: 'Nikki Kumari',
      amount: 1247,
      isSelected: true,
      reason: null,
      id: 5
    },
    {
      cn: '1245',
      instrument: 'Cash',
      collectedBy: 'Nikki Kumari',
      amount: 1247,
      isSelected: true,
      reason: null,
      id: 6
    }
  ]
};

export const denominations = [
  {
    value: '2000 X'
  },
  {
    value: '500 X'
  },
  {
    value: '100 X'
  },
  {
    value: '50 X'
  },
  {
    value: '10 X'
  },
  {
    value: '5 X'
  },
  {
    value: 'Other'
  },
  {
    value: 'Grand Total'
  }
];
// console.log(zoomTableActionsConfig);
